import 'formdata-polyfill';
import axios from 'axios';
import loadHandler from './helpers/loadHandler';
import Utils from '../../src/common/scripts/utils';
import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const dev = process.env.NODE_ENV === 'development';

// const url = '/tests/visual/building.json';

const url = dev ? '/ajax/searchvisual.php' : '/api/estateSearchVisual/';
const defRotate = '1';

/**
 * Возвращает данные в зависимости от текущего состояния поворота.
 * @param {object} state - общий стейт приложения
 * @param {string} element - поле стейта из которого нужно получить данные
 * @returns {object} объект с данными
 */
const getData = (state, element) => {
    const rotate = state.rotate;
    const data = state.data[element];

    return data ? data[rotate] : {};
};

const getCurrentFloorData = (floor, data) => {
    const floorID = Number(floor);
    const result = {};

    data.floors.forEach((item) => {
        const id = Number(item.id);

        if (id === floorID) {
            result.render = item.render;
            result.elements = item.elements;
        }
    });

    return result;
};

const setModifyHeader = (floor = false) => {
    const header = document.querySelector('.j-header');

    header.classList.add('header_theme_fixed');

    return floor ? header.classList.add('header_theme_white-text') : header.classList.remove('header_theme_white-text');
};

export default new Vuex.Store({
    /**
     * Глобальное хранилище для всего приложения
     * Доступ только через геттеры, изменение через мутацию.
     */
    state: {
        data: {
            render        : '',
            elements      : '',
            pointers      : '',
            infrastructure: '',
            floors        : '',
            breadcrumbs   : '',
            views         : [],
            compass       : '',
            panorama      : []
        },
        canvasSize: {
            width : 0,
            height: 0
        },
        filters : {},
        dataStep: {},
        form    : '',
        formData: '',
        rotate  : 1,
        isProc  : false,
        isReady : false,
        slice   : true,
        redirect: '',
        isPinch : false
    },

    /**
     * Методы для получения данных из стейта.
     */
    getters: {
        GET_RENDER(state) {
            return getData(state, 'render');
        },

        GET_ELEMENTS(state) {
            return getData(state, 'elements');
        },

        GET_CANVAS_SIZE(state) {
            return state.canvasSize;
        },

        GET_FILTERS(state) {
            return state.filters;
        },

        GET_POINTERS(state) {
            return getData(state, 'pointers');
        },

        GET_INFRASTRUCTURE(state) {
            return getData(state, 'infrastructure');
        },

        GET_FLOORS(state) {
            return state.data.floors.sort((a, b) => {
                return b.id - a.id;
            });
        },

        GET_BREADCRUMBS(state) {
            return state.data.breadcrumbs;
        },

        GET_VIEWS(state) {
            return state.data.views;
        },

        GET_COMPASS(state) {
            return getData(state, 'compass');
        },

        GET_PANORAMA(state) {
            return getData(state, 'panorama');
        },

        GET_DATA_STEP(state) {
            return state.dataStep;
        },

        GET_FORM_DATA(state) {
            return state.formData;
        },

        GET_FORM(state) {
            return state.form;
        },

        GET_ROTATE(state) {
            return state.rotate;
        },

        GET_IS_PROCESSING(state) {
            return state.isProc;
        },

        GET_IS_READY(state) {
            return state.isReady;
        },

        /**
         * Возвращает, надо ли вписывать фоновое изображение в весь экран
         * @param {object} state - текущий стейт
         * @return {Boolean} - true, если надо, false, если нет
         */
        GET_SLICE(state) {
            return state.slice;
        },

        GET_REDIRECT(state) {
            return state.redirect;
        },

        GET_IS_PINCH(state) {
            return state.isPinch;
        }
    },

    /**
     * События которые введут за собой изменение стейта.
     * https://vuex.vuejs.org/ru/guide/actions.html
     */
    actions: {
        send(context, body) {
            context.commit('SET_IS_PROCESSING', true);
            context.commit('SET_DATA_STEP', body);
            context.commit('SET_FORM_DATA', 'init');

            return new Promise((resolve) => {
                axios.post(url, this.getters.GET_FORM_DATA)
                    .then((response) => {
                        const data = response.data.data;
                        let render = '';
                        let floorData = '';

                        // на шаге выбора квартир, приходит массив всех этажей нужно выбрать текущий.
                        if (body.floor) {
                            floorData = getCurrentFloorData(body.floor, data);

                            if (floorData.render) {
                                // eslint-disable-next-line no-negated-condition
                                render = typeof floorData.render[defRotate].link !== 'undefined' ?
                                    floorData.render[defRotate].link :
                                    '';
                            } else {
                                console.error(`Floor with id ${body.floor} not found`);
                            }
                        } else {
                            // eslint-disable-next-line no-negated-condition
                            render = typeof data.render[defRotate].link !== 'undefined' ?
                                data.render[defRotate].link :
                                '';
                        }

                        context.commit('SET_REDIRECT', data);

                        if (data.redirect && !render) {
                            resolve();

                            return;
                        }

                        loadHandler(render)
                            .then((size) => {
                                context.commit('SET_CANVAS_SIZE', size);
                                context.commit('SET_DEFAULT_ROTATE');
                                context.commit('SET_DATA', data);
                                context.commit('SET_FILTERS', data);

                                if (body.floor) {
                                    context.commit('SET_FLOORS', floorData);
                                }

                                context.commit('SET_IS_PROCESSING', false);
                                context.commit('SET_IS_READY');
                                context.commit('SET_SLICE', body);
                                context.commit('SET_IS_PINCH', true);

                                setModifyHeader(body.floor);
                                resolve();
                            })
                            .catch(() => {
                                throw new Error('При получении рендера произошла ошибка');
                            });
                    })
                    .catch((error) => {
                        throw new Error(`При получении данных произошла ошибка ${error}`);
                    });
            });
        },

        changeFilter(context, form) {
            context.commit('SET_FORM', form);
            context.commit('SET_FORM_DATA', 'filter');
            context.commit('SET_IS_PROCESSING', true);

            axios.post(url, context.getters.GET_FORM_DATA)
                .then((response) => {
                    const data = response.data.data;
                    const floorId = this.getters.GET_DATA_STEP.floor;

                    context.commit('SET_ELEMENTS', data);

                    if (floorId) {
                        context.commit('UPDATE_FLOORS', data);

                        const floorData = getCurrentFloorData(floorId, data);

                        context.commit('SET_FLOORS', floorData);
                    }

                    context.commit('SET_IS_PROCESSING', false);
                })
                .catch((error) => {
                    console.error(`При фильтрации произошла ошибка= ${error}`);
                });
        },


        changeFloor(context, floor) {
            context.commit('SET_IS_PROCESSING', true);

            const floorData = getCurrentFloorData(floor, this.state.data);
            const render = floorData.render[this.getters.GET_ROTATE].link;

            loadHandler(render)
                .then(() => {
                    context.commit('SET_FLOORS', floorData);
                    context.commit('SET_IS_PROCESSING', false);
                });
        },

        changeRotate(context, id) {
            context.commit('SET_ROTATE', id);
        },

        changePosition(context, data) {
            context.commit('SET_POSITION_ELEMENTS', data);
        },

        changeStateLoading(context, state) {
            context.commit('SET_IS_PROCESSING', state);
        },

        changeStatePinch(context, state) {
            context.commit('SET_IS_PINCH', state);
        }
    },

    /**
     * Методы для изменения стейта.
     */
    mutations: {
        SET_CANVAS_SIZE(state, data) {
            state.canvasSize = data;
        },

        SET_DATA(state, data) {
            state.data = data;
        },

        SET_ELEMENTS(state, data) {
            state.data.elements = data.elements;
        },

        SET_FILTERS(state, data) {
            state.filters = data.filters || {};
        },

        SET_FLOORS(state, data) {
            Vue.set(state.data, 'render', data.render);
            Vue.set(state.data, 'elements', data.elements);
        },

        UPDATE_FLOORS(state, data) {
            state.data.floors = data.floors;
        },

        SET_ROTATE(state, rotate) {
            this.commit('SET_IS_PROCESSING', true);

            const render = state.data.render[rotate].link;

            loadHandler(render)
                .then(() => {
                    state.rotate = rotate;
                    this.commit('SET_IS_PROCESSING', false);
                });
        },

        SET_DEFAULT_ROTATE(state) {
            state.rotate = defRotate;
        },

        SET_DATA_STEP(state, data) {
            state.dataStep = data;
        },

        SET_FORM(state, form) {
            state.form = form;
        },

        SET_FORM_DATA(state, type) {
            const form = this.getters.GET_FORM;
            const dataStep = this.getters.GET_DATA_STEP;

            state.formData = form ? new FormData(form) : new FormData();

            for (const item in dataStep) {
                if (Utils.keyExist(dataStep, item)) {
                    state.formData.append(item, dataStep[item]);
                }
            }

            state.formData.append('type', type);
        },

        SET_IS_PROCESSING(state, value) {
            state.isProc = value;
        },

        SET_IS_READY(state) {
            state.isReady = true;
        },

        /**
         * Мутация растягивает свг на весь экран если это не flat (на основании шага)
         * @param {object} state - текущий стейт
         * @param {object} body - текущий шаг
         */
        SET_SLICE(state, body) {
            state.slice = body.step !== 'flat';
        },

        SET_POSITION_ELEMENTS(state, data) {
            const elements = getData(state, data.type);

            if (elements) {
                elements.forEach((item, index) => {
                    if (item) {
                        item.reposition = data.coords[index];
                    }
                });
            }
        },

        SET_REDIRECT(state, data) {
            const redirect = data.redirect || '';

            state.redirect = redirect.match(/^([a-z0-9\-/]+)$/g) ?
                redirect :
                '';
        },

        SET_IS_PINCH(state, value) {
            state.isPinch = value;
        }
    }
});
